import React from 'react';
import { FadeIn } from './FadeIn';
export function StatsAndTestimonials() {
  return <section className="py-8 bg-surface border-y border-white/5" data-id="element-377">
      <div className="container mx-auto px-4" data-id="element-378">
        <FadeIn data-id="element-379">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-4 divide-x-0 md:divide-x divide-white/10 mb-8" data-id="element-380">
            <div className="flex flex-col items-center text-center px-4" data-id="element-381">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-382">
                🏭
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-383">
                +300
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-384">
                Talleres confían
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-385">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-386">
                📚
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-387">
                6
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-388">
                Tomos listos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-389">
              <span className="text-3xl mb-3" aria-hidden="true" data-id="element-390">
                🎁
              </span>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-391">
                4
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-392">
                Bonos incluidos
              </span>
            </div>
            <div className="flex flex-col items-center text-center px-4" data-id="element-393">
              <div className="flex gap-1 mb-3" data-id="element-394">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-lg" data-id="element-395">
                    ★
                  </span>)}
              </div>
              <span className="text-2xl font-bold text-white font-heading" data-id="element-396">
                4.9/5
              </span>
              <span className="text-sm text-gray-400 uppercase tracking-wider" data-id="element-397">
                Calificación
              </span>
            </div>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-398">
          <FadeIn delay={0.1} data-id="element-399">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-400">
              <div className="flex gap-1 mb-4" data-id="element-401">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-402">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-403">
                "Armé el primer trabajo con el sistema y no tuve que medir dos
                veces. Las tablas de descuento me cambiaron la vida."
              </p>
              <div className="flex items-center gap-3" data-id="element-404">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-405">
                  J
                </div>
                <div data-id="element-406">
                  <p className="font-bold text-white text-sm" data-id="element-407">Jorge R.</p>
                  <p className="text-xs text-gray-500" data-id="element-408">Córdoba</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-409">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-410">
              <div className="flex gap-1 mb-4" data-id="element-411">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-412">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-413">
                "Le di los planos a mi ayudante y fabricó solo. Por primera vez
                no tuve que estar encima de todo."
              </p>
              <div className="flex items-center gap-3" data-id="element-414">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-415">
                  M
                </div>
                <div data-id="element-416">
                  <p className="font-bold text-white text-sm" data-id="element-417">Marcelo P.</p>
                  <p className="text-xs text-gray-500" data-id="element-418">
                    Rosario · Taller de Aluminio
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.3} data-id="element-419">
            <div className="bg-background p-6 rounded-2xl border border-white/5 h-full flex flex-col" data-id="element-420">
              <div className="flex gap-1 mb-4" data-id="element-421">
                {[...Array(5)].map((_, i) => <span key={i} className="text-yellow text-sm" data-id="element-422">
                    ★
                  </span>)}
              </div>
              <p className="text-gray-300 italic mb-6 flex-grow" data-id="element-423">
                "El Tomo 6 de presupuestos me hizo darme cuenta que estaba
                trabajando sin ganancia real. Ahora cobro lo que corresponde."
              </p>
              <div className="flex items-center gap-3" data-id="element-424">
                <div className="w-10 h-10 rounded-full bg-surfaceLight flex items-center justify-center font-bold text-gold" data-id="element-425">
                  C
                </div>
                <div data-id="element-426">
                  <p className="font-bold text-white text-sm" data-id="element-427">Carlos A.</p>
                  <p className="text-xs text-gray-500" data-id="element-428">Buenos Aires</p>
                </div>
              </div>
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}